import { FC, ReactNode } from "react";
import { GeneralContextProvider } from "./generalContext";
import { UserContextProvider } from "./userContext";
import { OrganisationContextProvider } from "./organisationContext";
import { BasketContextProvider } from "./basketContextProvider";
import { ProductContextProvider } from "./productContext";
import { CategoryContextProvider } from "./categoryContext";
import { ClientContextProvider } from "./clientContext";
import { SalesContextProvider } from "./salesContext";
import { DashboardContextProvider } from "./dashboardContext";
import { AssistantContextProvider } from "./assistantContext";
import { InventoryProvider } from "./inventoryContext";
import { CreditsContextProvider } from "./creditsContext";
import { PromotionContextProvider } from "./promotionContext";
import { SubscriptionContextProvider } from "./subscriptionContext";

interface IAppContextProvider {
    children: ReactNode
}

export const AppContextProvider: FC<IAppContextProvider> = ({ children }) => {
    return (
        <GeneralContextProvider>
            <UserContextProvider>
                <OrganisationContextProvider>
                    <ProductContextProvider>
                        <CategoryContextProvider>
                            <BasketContextProvider>
                                <ClientContextProvider>
                                    <SalesContextProvider>
                                        <AssistantContextProvider>
                                            <DashboardContextProvider>
                                                <InventoryProvider>
                                                    <CreditsContextProvider>
                                                        <PromotionContextProvider>
                                                            <SubscriptionContextProvider>
                                                                {children}
                                                            </SubscriptionContextProvider>
                                                        </PromotionContextProvider>
                                                    </CreditsContextProvider>
                                                </InventoryProvider>
                                            </DashboardContextProvider>
                                        </AssistantContextProvider>
                                    </SalesContextProvider>
                                </ClientContextProvider>
                            </BasketContextProvider>
                        </CategoryContextProvider>
                    </ProductContextProvider>
                </OrganisationContextProvider>
            </UserContextProvider>
        </GeneralContextProvider>
    )
}
